

@if (link?.children?.length > 0 && link?.title?.length > 0) {
    <button [attr.tabindex]="isMobile ? null : -1"
            [attr.linkId]="link.id"
            [attr.selected]="link === selected"
            (click)="select.emit(link === selected ? link.prev : link)">
            <svg  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  role="img"
                  aria-hidden="true"
                  focusable="false">
                <use xlink:href="#chevron-left"
                    href="#chevron-left"></use>
            </svg>
            <span>{{ link.title }}</span>
            <svg  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  role="img"
                  aria-hidden="true"
                  focusable="false">
                <use xlink:href="#chevron-right"
                    href="#chevron-right"></use>
            </svg>
        </button>
        <div class="head" [attr.linkId]="link.id"
        [class.has-button]="link?.children?.length"
        >{{ link.title }}</div>
    } @else if(link.link) {
        <a  [attr.linkId]="link.id"
        [class.has-button]="link?.children?.length"
        [routerLink]="link.link">{{ link.title }}</a>
    } @else {
       <div class="text" [attr.linkId]="link.id"
        [class.has-button]="link?.children?.length"
        >{{ link.title }}</div>
    }


@if(link?.children?.length > 0) {
    <div [class.has-no-button]="!(link?.title?.length > 0)">
        @for (_link of link?.children; track _link.id) {
            <app-recursive-link [link]="_link"
                                [attr.open]="_link==selected ? '' : null"
                                [selected]="selected"
                                (select)="select.emit($event)"></app-recursive-link>
        }
        <!-- <a [attr.linkId]="link.id"
            [attr.tabindex]="link === selected ? -1 : (isMobile ? -1 : null)"
            [routerLink]="link.link"
            class="menu-all">{{ 'MENU.MENU_ALL' | translate:{link:link.title }  }}</a> -->
    </div>
}
